import React, { useEffect } from 'react';
import { Nav } from './components/Nav';
import { Hero } from './components/Hero';
import { Marquee } from './components/Marquee';
import { Problem } from './components/Problem';
import { Author } from './components/Author';
import { Contents } from './components/Contents';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FinalOffer } from './components/FinalOffer';
import { FAQ } from './components/FAQ';
import { Urgency } from './components/Urgency';
import { EmotionalClose } from './components/EmotionalClose';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full min-h-screen bg-[#FAF7F0]" data-id="element-0">
      <Nav data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Marquee data-id="element-4" />
        <Problem data-id="element-5" />
        <Author data-id="element-6" />
        <Contents data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Testimonials data-id="element-9" />
        <FinalOffer data-id="element-10" />
        <Guarantee data-id="element-11" />
        <Urgency data-id="element-12" />
        <FAQ data-id="element-13" />
        <EmotionalClose data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>
      <Footer data-id="element-16" />
    </div>;
}